module.exports = __webpack_public_path__ + "img/carbon.a474b6b.jpg";